export default function Error(){
    return(
        <h2>Wrong URL..!!!</h2>
    )
}